// src/components/Sidebar.js
import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  QrCode,
  History,
  Palette,
  Layers,
  KeyRound,
  File,
  Camera,
  Settings,
  HelpCircle,
  Menu,
  X,
  QrCodeIcon,
  ArrowLeft,
} from "lucide-react";

export default function Sidebar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const menu = [
    { title: "Create QR", path: "/qrgenerator", icon: <QrCode size={18} /> },
    // { title: "My QR Codes", path: "/my-qr-codes", icon: <History size={18} /> },
    { title: "QR Styling", path: "/qrstyling", icon: <Palette size={18} /> },
    { title: "QR Types", path: "/qrtypes", icon: <Layers size={18} /> },
    { title: "File to QR", path: "/filetoqr", icon: <File size={18} /> },
    // { title: "QR Scanner", path: "/qr-scanner", icon: <Camera size={18} /> },
    // { title: "Settings", path: "/settings", icon: <Settings size={18} /> },
    // { title: "Help / FAQ", path: "/help", icon: <HelpCircle size={18} /> },
  ];

  return (
    <>
{/* Mobile Top Bar */}
<div className="md:hidden flex items-center justify-between bg-white shadow px-4 py-3 fixed top-0 left-0 right-0 z-50">
  {/* Hamburger Menu */}
<button 
  onClick={() => setOpen(!open)} // toggle sidebar open/close
  className="p-2 rounded-lg hover:bg-gray-100"
>
  {open ? <X size={22} /> : <Menu size={22} />}
</button>


  {/* Logo + Title */}
  <div className="flex items-center gap-2 text-cyan-700 font-bold text-lg">
    <QrCodeIcon className="w-6 h-6" />
    <span>QR Generator</span>
  </div>

  {/* Back Button */}
  <button
    onClick={() => navigate("/tools")}
    className="flex items-center gap-1 text-cyan-700 font-medium hover:text-cyan-600 transition"
  >
    <ArrowLeft className="w-4 h-4" />
    <span className="text-sm">Back</span>
  </button>
</div>


      {/* Sidebar */}
      <aside
        className={`bg-white shadow-lg w-64 fixed top-0 left-0 h-screen z-40 p-6 space-y-6 transform transition-transform duration-300
        ${open ? "translate-x-0" : "-translate-x-full"} md:translate-x-0`}
      >
        {/* Close button for mobile */}
        <div className="flex items-center justify-between md:hidden mb-6">
          <div className="flex items-center gap-2 text-cyan-700 font-bold text-lg">
            <QrCodeIcon className="w-6 h-6" />
            <span>QR Generator</span>
          </div>

          <button onClick={() => setOpen(false)} className="p-2 rounded-lg hover:bg-gray-100">
            <X size={22} />
          </button>
        </div>

        {/* Logo (desktop only) */}

        <div className="hidden md:flex items-center gap-2 text-cyan-700 font-bold text-lg">
          <QrCodeIcon className="w-6 h-6" />
          QR Generator
        </div>


        {/* Menu */}
<nav className="space-y-2 mt-10 md:mt-0">
  {menu.map((item, i) => {
    const isActive = location.pathname === item.path;
    return (
      <Link
        key={i}
        to={item.path}
        onClick={() => setOpen(false)} // close on mobile click
        className={`flex items-center gap-3 px-4 py-2 rounded-lg transition-all duration-200
          ${isActive 
            ? "bg-cyan-100 text-cyan-700 font-medium hover:bg-cyan-200" 
            : "text-gray-700 hover:bg-gray-100 hover:text-cyan-700"
          }`}
      >
        <span
          className={`transition-colors duration-200
            ${isActive ? "text-cyan-700" : "text-gray-500 group-hover:text-cyan-700"}`}
        >
          {item.icon}
        </span>
        {item.title}
      </Link>
    );
  })}
</nav>


      </aside>

      {/* Backdrop for mobile */}
      {open && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-30 md:hidden"
          onClick={() => setOpen(false)}
        ></div>
      )}
    </>
  );
}
